module.exports = __webpack_public_path__ + "static/mentor-vivek-223c95e950a87a2375bf8c9d09bd96f6.jpg";